export const routes = (prefix = `pharmacy`) => [
    {
        path: `/${prefix}/patients`,
        name: `${prefix}.patients.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patients.index`,
                PageDescription: "Pharmacy - Select patient",
            },
        },
    },
];
